import type { CreateAppConfig } from '@steinpilz/react-ux';
import { getUrl } from '@infrastructure/api/client/utils';
import { configuration } from '@configs/client';

export const appConfig: CreateAppConfig<{ base: string }, Record<string, unknown>> = {
  init: {
    base: getUrl(''),
  },
  async withRouterConfig() {
    const { baseName } = await import('@api/client/constants');

    const hasExtra = baseName?.length > 1 && baseName.slice(-1) === '/';
    const newBaseName = hasExtra ? baseName.slice(0, -1) : baseName;

    return {
      basename: newBaseName,
    };
  },
  withTheme: {
    namespace: 'mbag',
  },
  async withl10n({ init }) {
    const isStatic = configuration.useStaticResources();

    if (isStatic) {
      const { staticResources } = await import('@i10n/index');

      return {
        endpoint: {
          staticResources,
        },
      };
    }

    return {
      endpoint: {
        url: '/modules/host/api/config',
        moduleName: 'Fria2.TextResources',
        base: init.base,
      },
      resourcesQueryParams: {
        environment: '1',
      },
    };
  },
};
